export const VERSION = 562949954273281;
